import { PropertySpecificsModuleViewModel } from "src/app/views/pages/valuation/background/property-specific-section/types"
import { ValuationProcessTargetPropertyModel } from "../../v2/state/valuation-process/types/asset-class/target-property"
import { SPECIAL_PURPOSES } from "../comparable/special-purpose/property-types"

export function mapTargetPropertyToPropertySpecificsViewModel(tp: ValuationProcessTargetPropertyModel): PropertySpecificsModuleViewModel {
  if (tp == null || tp.generalInfo == null) {
    return null
  }
  switch (tp.generalInfo.propertySubType) {
    case 'Apartment': {
      return {
        kind: 'Apartment',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        bedroom: tp.generalInfo.bedroom,
        selectedExternalAreas: tp.generalInfo.selectedExternalArea,
        buildingGrade: tp.buildingInfo.buildingGrade,
        buildingType: tp.buildingInfo.buildingType
      }
    }
    case 'House': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'House',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        propertyGrade: tp.generalInfo.propertyGrade
      }
    }
    case 'Office': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'Office',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        selectedExternalAreas: tp.generalInfo.selectedExternalArea,
        buildingGrade: tp.buildingInfo.buildingGrade,
        buildingType: tp.buildingInfo.buildingType
      }
    }
    case 'Retail Shop': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'Retail Shop',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        selectedExternalAreas: tp.generalInfo.selectedExternalArea,
        buildingGrade: tp.buildingInfo.buildingGrade,
        buildingType: tp.buildingInfo.buildingType
      }
    }
    case 'Retail Building': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'Retail Building',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        propertyGrade: tp.generalInfo.propertyGrade
      }
    }
    case 'Parking': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'Parking',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
      }
    }
    case 'Warehouse': {
      // const hasSizeTable = tp.generalInfo.measurementStandardId >= 1 && tp.instructedToMeasure && this.smUtility.checkHasOwnTable(tp.generalInfo.measurementStandardId)
      return {
        kind: 'Warehouse',
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        subTypeCategory: tp.generalInfo.subTypeCategoryName,
        subCategory: tp.generalInfo.subCategoryName,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        propertyGrade: tp.generalInfo.propertyGrade
      }
    }
    case 'Land': {
      return {
        kind: 'Land',
        locationGrade: tp.generalInfo.locationGrade,
        coordinateReferenceSystem: tp.generalInfo.coordinateReferenceSystemName,
        landParcelNum: tp.generalInfo.totalLandParcel,
        totalLandArea: tp.generalInfo.totalLandArea,
        unitMeasurement: tp.generalInfo.unitMeasurement,
        planningStatus: tp.generalInfo.planningStatusName,
        numOfBuilding: tp.generalInfo.numOfBuilding,
        targetPropertyId: tp.id,
        propertyType: tp.generalInfo.propertyTypeName,
        propertySubType: tp.generalInfo.propertySubTypeName,
        longitude: tp.generalInfo.locationData.longitude,
        latitude: tp.generalInfo.locationData.latitude,
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
      }
    }
    case 'Special Purpose': {
      return {
        kind: 'Special Purpose',
        address: `${tp.generalInfo.locationData.address} - ${tp.generalInfo.locationData.cityName} - ${(tp.generalInfo.locationData.zipCode ? tp.generalInfo.locationData.zipCode + ' - ' : '')} ${tp.generalInfo.locationData.countryName}`,
        latitude: tp.generalInfo.locationData.latitude,
        longitude: tp.generalInfo.locationData.longitude,
        propertySubType: null,
        propertyType: 'Special Purpose',
        targetPropertyId: tp.id,
        locationGrade: tp.generalInfo.locationGrade,
        measurementStandard: _getStandardMeasurementName(tp.generalInfo.measurementStandard),
        measurementStandardModel: tp.generalInfo.measurementStandardModel,
        accommodation: tp.generalInfo.accommodation,
        floorNumberinSchemeId: tp.generalInfo.floorNumberingSchemeId,
        size: {
          value: tp.generalInfo.size,
          unitAreaMeasurement: tp.generalInfo.unitAreaMeasurementAcronym,
          isClickable: false,
          unitAreaMeasurementModel: tp.generalInfo.unitAreaMeasurementModel,
        },
        specialPurposeType: tp.generalInfo.specialPurposeType 
      }
    }
  }
}

function _getStandardMeasurementName(name: string): string {
  if (name.indexOf('-') == -1) {
    return name
  }
  return name.substring(0, name.indexOf('-'))
}

function _getSpecialPurposeType(id: number) {
  return SPECIAL_PURPOSES.find(item => item.id === id)?.name ?? null
}